<template>
  <div
    class="cookie-consent-banner fixed z-20 bottom-6 left-1/2 -translate-x-1/2 px-5 pt-4 pb-6 flex flex-col justify-center items-start gap-4 self-stretch border border-slate-200 bg-white shadow-cookieBanner"
    data-target="cookie-consent-banner"
  >
    <div
      class="cookie-consent-banner-header flex gap-3 items-center justify-center"
    >
      <div
        class="cookie-icon-container p-1 inline-flex items-center justify-center rounded bg-secondary-100"
      >
        <Icon
          name="material-symbols:cookie-outline"
          size="1.25rem"
          class="text-secondary-600"
        />
      </div>
      <p class="text-slate-900 text-base font-bold">
        {{ title }}
      </p>
    </div>
    <div class="cookie-consent-banner-body flex flex-col gap-2">
      <p class="text-slate-600 text-base font-bold">
        {{ subtitle }}
      </p>
      <!-- eslint-disable vue/no-v-html -->
      <p class="text-slate-600 text-sm font-medium" v-html="description"></p>
    </div>
    <div class="cookie-consent-banner-footer flex justify-between w-full">
      <PrimaryButton
        variant="primary-ghost"
        @on-click="emit('managePreferences')"
      >
        <div class="flex items-center justify-center gap-1">
          <Icon name="material-symbols:settings-outline" size="1rem" />
          <p class="!text-sm !font-semibold">
            {{ managePreferencesLabel }}
          </p>
        </div>
      </PrimaryButton>
      <div class="flex items-center gap-2">
        <PrimaryButton
          variant="outline-secondary-neutral"
          @on-click="emit('acceptEssentialCookiesOnly')"
          ><p>
            {{ acceptEssentialCookiesOnlyLabel }}
          </p></PrimaryButton
        >
        <PrimaryButton @on-click="emit('acceptAll')"
          ><p>{{ acceptAllLabel }}</p></PrimaryButton
        >
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import PrimaryButton from "~/components/shared/primary-button/PrimaryButton.vue";
defineProps<{
  title: string;
  subtitle: string;
  description: string;
  managePreferencesLabel: string;
  acceptEssentialCookiesOnlyLabel: string;
  acceptAllLabel: string;
}>();
const emit = defineEmits<{
  managePreferences: [];
  acceptEssentialCookiesOnly: [];
  acceptAll: [];
}>();
</script>
